"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackEvent = void 0;

var _types = require("./types");

var trackEvent = function trackEvent(eventFnc) {
  return function (dispatch, getState, _ref) {
    var tracker = _ref.tracker;
    eventFnc(tracker);
    return {
      type: _types.TRACK_EVENT
    };
  };
};

exports.trackEvent = trackEvent;